var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllYouNeedExtension(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 171,
    viewBox: "0 0 365 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.014,
    y: 120.199,
    width: 65.5132,
    height: 65.5132,
    rx: 13.5,
    transform: "rotate(-45 131.014 120.199)",
    fill: "#43FFA8",
    stroke: "#0A1214"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.513,
    y: 119.768,
    width: 65.5132,
    height: 65.5132,
    rx: 13.5,
    transform: "rotate(-45 141.513 119.768)",
    fill: "#34DBFF",
    stroke: "#0A1214"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.991 134.564H180.788V128.115M180.788 128.115V112.637H190.533C192.482 113.067 196.38 115.217 196.38 120.376C196.38 126.825 191.183 128.115 190.533 128.115C190.013 128.115 183.82 128.115 180.788 128.115Z",
    stroke: "#0A1214"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.63 128.086H173.722V106.059H191.963C195.872 106.275 203.689 109.427 203.689 120.311C203.689 133.916 192.614 134.564 191.963 134.564C191.442 134.564 187.837 134.564 186.1 134.564",
    stroke: "#0A1214"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.229 77.5527C131.974 77.5527 130.571 77.735 129.021 78.0995C127.544 78.464 126.252 79.1202 125.145 80.0679C124.111 81.0157 123.557 82.4373 123.484 84.3328L122.487 108.282C122.339 111.927 121.49 114.77 119.94 116.812C118.389 118.853 115.51 119.874 111.302 119.874V120.858C114.107 120.858 116.285 121.332 117.836 122.28C119.46 123.227 120.604 124.576 121.269 126.326C122.007 128.003 122.413 130.044 122.487 132.45L123.484 156.29C123.557 158.112 124.111 159.497 125.145 160.445C126.252 161.466 127.544 162.158 129.021 162.523C130.497 162.887 131.9 163.07 133.229 163.07",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.104 163.07C232.359 163.07 233.762 162.888 235.312 162.523C236.789 162.159 238.081 161.503 239.188 160.555C240.222 159.607 240.776 158.186 240.849 156.29L241.846 132.341C241.994 128.696 242.843 125.852 244.393 123.811C245.944 121.77 248.823 120.749 253.031 120.749L253.031 119.765C250.226 119.765 248.048 119.291 246.497 118.343C244.873 117.396 243.729 116.047 243.064 114.297C242.326 112.62 241.92 110.579 241.846 108.173L240.849 84.3334C240.776 82.5108 240.222 81.1256 239.188 80.1778C238.081 79.1572 236.789 78.4646 235.312 78.1C233.836 77.7355 232.433 77.5533 231.104 77.5533",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.666 49.0491H248.81C249.362 49.0491 249.81 48.6013 249.81 48.0491V19.8125",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.975 8.48047H185.759C185.207 8.48047 184.759 8.92818 184.759 9.48047V66.2227",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.735 66.2227V38.3516C161.735 37.7993 161.287 37.3516 160.735 37.3516H127.842",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.843,
    cy: 9.21277,
    r: 5.71277,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.348,
    cy: 36.9742,
    r: 7.54647,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.808,
    cy: 15.7915,
    r: 3.52003,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllYouNeedExtension);
export default __webpack_public_path__ + "static/media/allYouNeedExtension.4cde40ef08dc85d03fb8f16977e36c57.svg";
export { ForwardRef as ReactComponent };